import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "header"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "padding-top": "18px",
    "padding-left": "30px"
  },
  src: "/assets/icon/upi.png",
  alt: ""
}, null, -1);

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "doubttext"
}, "How to pay ?", -1);

const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "van-doc-card"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" method 1 ");

const _hoisted_8 = {
  class: "amount"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", {
  style: {
    "border-top": "1px solid #5728a8"
  }
}, null, -1);

const _hoisted_10 = {
  class: "content"
};
const _hoisted_11 = {
  class: "paytma"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Click To Pay ");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("OR");

const _hoisted_14 = {
  class: "van-doc-card"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Save QR and to pay");

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" method 2 ");

const _hoisted_17 = ["src", "data-name", "data-url"];
const _hoisted_18 = {
  class: "content"
};
const _hoisted_19 = {
  style: {
    "text-align": "center"
  }
};

const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Use Mobile Scan code to pay", -1);

const _hoisted_21 = {
  class: "qrcodegroup"
};

const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "title2"
}, "Do not use the same QR code to pay multiple times", -1);

const _hoisted_23 = {
  key: 0,
  class: "van-doc-card2",
  id: "posterHtml"
};
const _hoisted_24 = {
  class: "content"
};
const _hoisted_25 = {
  style: {
    "text-align": "center"
  }
};

const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Use Mobile Scan code to pay", -1);

const _hoisted_27 = {
  class: "qrnote3"
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  class: "qrcodegroup"
};

const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "qrnote2"
}, [/*#__PURE__*/_createElementVNode("div", null, "1. If payment fails, please change payment APP and Scan Qr to pay again"), /*#__PURE__*/_createElementVNode("div", null, "2. Same QR can only be pay successfully once")], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_badge = _resolveComponent("van-badge");

  const _component_van_image = _resolveComponent("van-image");

  const _component_van_button = _resolveComponent("van-button");

  const _component_van_divider = _resolveComponent("van-divider");

  const _component_qrcode_vue = _resolveComponent("qrcode-vue");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    class: "doubt",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.payment_assistant && $options.payment_assistant(...args))
  }, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_badge, {
    position: "top-left"
  }, {
    content: _withCtx(() => [_hoisted_7]),
    _: 1
  }), _createElementVNode("div", _hoisted_8, "Pay ₹ " + _toDisplayString($data.amount), 1), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_van_image, {
    src: "/assets/icon/paytm.png"
  }), _createVNode(_component_van_button, {
    type: "primary",
    onClick: $options.gopay
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["onClick"])])])])]), _createVNode(_component_van_divider, {
    style: {
      color: '#FF8C00',
      borderColor: '#FF8C00',
      padding: '0 16px'
    }
  }, {
    default: _withCtx(() => [_hoisted_13]),
    _: 1
  }), _createElementVNode("div", _hoisted_14, [_createVNode(_component_van_button, {
    type: "primary",
    icon: "scan",
    class: "scanbtn",
    onClick: $options.scanpay,
    disabled: $data.posterImg === ''
  }, {
    default: _withCtx(() => [_hoisted_15]),
    _: 1
  }, 8, ["onClick", "disabled"]), _createVNode(_component_van_badge, {
    position: "top-left"
  }, {
    content: _withCtx(() => [_hoisted_16]),
    _: 1
  }), $data.posterImg !== '' ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.posterImg,
    id: "posterimg",
    "data-name": $data.orderinfo.merchant_orderno + '.png',
    "data-url": 'https://indshop.one/qrcode/' + $data.orderno,
    hidden: ""
  }, null, 8, _hoisted_17)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createVNode(_component_qrcode_vue, {
    value: $data.qvalue,
    size: $data.size,
    id: "qrcode",
    level: "H"
  }, null, 8, ["value", "size"])]), _hoisted_22, _createVNode(_component_van_image, {
    src: "/assets/icon/upis.png"
  })])])]), $data.posterisshow ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [$data.posterContent !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString($data.posterContent), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, "OrderID: " + _toDisplayString($data.orderinfo.merchant_orderno), 1), _createElementVNode("div", null, "Amount: " + _toDisplayString($data.amount), 1)]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_qrcode_vue, {
    value: $data.qvalue,
    size: $data.postersize,
    id: "qrcode",
    level: "H"
  }, null, 8, ["value", "size"])]), _hoisted_30, _createVNode(_component_van_image, {
    src: "/assets/icon/upis.png"
  })])])])) : _createCommentVNode("", true)], 64);
}